<h2>they call me</h2>
<h1><em>Simon</em></h1>
<a routerLink="/bio">who's that?</a>